import { render, staticRenderFns } from "./ChatOrderModalAddProduct.vue?vue&type=template&id=ce5fe096&scoped=true&"
import script from "./ChatOrderModalAddProduct.vue?vue&type=script&lang=js&"
export * from "./ChatOrderModalAddProduct.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderModalAddProduct.vue?vue&type=style&index=0&id=ce5fe096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5fe096",
  null
  
)

export default component.exports